const apiBaseurl = `/api`
const adminApiBaseurl = `/api`
const payApiBaseurl = `/billing`
const walletApiBaseurl = `/api/wallet`
const noticeApiBaseurl = `/api/notice`
let accountApiBaseurl = `/api/account`
let sffApiBaseurl = `/api/bff/console/miniapp/api`
let strapiBaseurl = `/api/strapi`
let painetApiurl = 'https://api.painet.work'
let wsUrl = `wss://api.paigod.work/v1/ws`

if (process.env.REACT_APP_API_ENV !== 'production') {
  wsUrl = 'wss://api.test.paigod.work/v1/ws'
  painetApiurl = 'https://api-test.painet.work'
}

const kvAPiBaseurl = `https://${
  process.env.REACT_APP_API_ENV !== 'prod' ? 'aps-kv-store' : 'aps-kv-store'
}.pedge.cloud` // pedge.cloud

export {
  wsUrl,
  apiBaseurl,
  payApiBaseurl,
  walletApiBaseurl,
  sffApiBaseurl,
  strapiBaseurl,
  adminApiBaseurl,
  noticeApiBaseurl,
  accountApiBaseurl,
  painetApiurl,
  kvAPiBaseurl,
}
